<template>
    <div id="peopleSummaryPane" class="q-pa-sm" v-bind="attrs">
        <div class="text-body2 q-pa-sm" v-if="finalData">
            <div class="text-h7 underline text-uppercase">Communities at Sea</div>
            <ul class="q-mt-xs">
                <li>{{  attrText['PEO_COM'][finalData['PEO_COM']] }}</li>
            </ul>
            <div class="text-h7 underline text-uppercase">Wind Energy Cables</div>
            <ul class="q-mt-xs">
                <li v-if="sumArray(finalData['PEO_CAB']) ==0">There are no undersea cables identified in the area</li>
                <li v-else-if="sumArray(finalData['PEO_CAB']) == 3">There both installed and proposed undersea cables identified in the area</li>
                <li v-else-if="sumArray(finalData['PEO_CAB']) == 2">There are installed undersea cables identified in the area</li>
                <li v-else-if="sumArray(finalData['PEO_CAB']) == 1">There are proposed undersea cables identified in the area</li>
            </ul>

            <div class="text-h7 underline text-uppercase">Other Uses</div>
            <ul class="q-mt-xs">
                <li>{{  attrText['PEO_ART'][finalData['PEO_ART']] }}</li>
                <li>{{  attrText['PEO_AIS'][finalData['PEO_AIS']] }}</li>
                <li>{{  attrText['PEO_FIS'][finalData['PEO_FIS']] }}</li>
                <li v-if="sumArray(finalData['PEO_SAN']) ==0">There are no OCS Aliquots with sand resources or BOEM sand resouces identified in the area</li>
                <li v-else-if="sumArray(finalData['PEO_SAN']) == 3">There both OCS Aliquots with sand resources and BOEM sand resouces identified in the area</li>
                <li v-else-if="sumArray(finalData['PEO_SAN']) == 2">There BOEM sand resouces identified in the area</li>
                <li v-else-if="sumArray(finalData['PEO_SAN']) == 1">There OCS Aliquots with sand resources identified in the area</li>
            </ul>


        </div>

    </div>

    <div v-for="(infoObj, name) in infoDialogs" :key="name" >
        <q-dialog v-model="infoObj.model">
            <InfoDialog  :html="infoObj.text" :name="infoObj.pName"/>
        </q-dialog>
    </div>
</template>
<script setup lang="ts">
import { toRefs, ref, computed, onMounted, useAttrs } from "vue";
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"
import InfoDialog from "./InfoDialog.vue";
const attrs = useAttrs()
const {  tileLayers, toggleLayer, print, printing, ecos, styleMap, setProcessedData, processedData, loadDataByID, activeLayerID } = useMapItems()
const { arrayFindObjectByProp, sumArray } = useHelpers();

const props = defineProps({
    data: { type: Object },
    version: {type: Number}
})

const { data, version } = toRefs(props)

const summaryData =  computed(() =>{
    if (data.value && data.value["PEOPLE_SUMMARY"] && data.value["PEOPLE_SUMMARY"].length >0){
        return data.value["PEOPLE_SUMMARY"]
    }
    else{ return null}
})


const finalData = computed(() => {
    if (
        !processedData.value[version.value] || 
        processedData.value[version.value]['PEOPLE_SUMMARY'] === undefined ||
        processedData.value[version.value]['PEOPLE_SUMMARY']['a'] === undefined ||
        processedData.value[version.value]['PEOPLE_SUMMARY']['a']['a'] === undefined
    ){
        if (summaryData.value) {
            const finalData = {}
            const workingData = {}
            Object.keys(attrText).forEach((attr) =>{
                workingData[attr] = []
            })

            /////////// PROCESS CELL DATA
            summaryData.value.forEach((cell) => {
                Object.keys(attrText).forEach((attr) =>{
                    workingData[attr].push(cell[attr])
                })
            })

            const maxAttrs = ["PEO_COM", "PEO_AIS", "PEO_FIS", "PEO_ART"]
            const unqiuesAttrs = ["PEO_CAB", "PEO_SAN"]

            maxAttrs.forEach((attr) =>{
                finalData[attr] = Math.max(...workingData[attr])
            })

            unqiuesAttrs.forEach((attr) =>{
                finalData[attr] = Array.from(new Set(workingData[attr]))
            })


            // console.log(finalData)
            setProcessedData(version.value, "PEOPLE_SUMMARY", 'a', 'a', finalData)
            return finalData
        }
        else{
            return null
        }
    }
    else{
        // console.log("Loading ", processedData.value[version.value]['PEOPLE_SUMMARY']['a']['a'])
        return processedData.value[version.value]['PEOPLE_SUMMARY']['a']['a']
    }
    
})

const attrText = {
    "PEO_COM": {
        "0" : "No Communities at Sea are present in the area",
        "1" :"Communities at Sea present in the area"
    },
    "PEO_AIS" : {
        "0" : "No or low volumes of commerical shipping is present in the area",
        "1" :"Commerical shipping is present in the area"
    },
    "PEO_FIS" : {
        "0" : "No or low volumes of commerical fishing is present in the area",
        "1" :"Commerical fishing is present in the area"
    },
	"PEO_CAB": "This area overlaps with known (Installed) and (proposed) cables",
	"PEO_ART": {
        "0": "This area does not overlap with known artificial reefs",
        "1" :"This area overlaps with known artificial reefs"
    },
	"PEO_SAN": "Within this area there are BOEM Sand Aliquots"

}

const infoDialogs = ref({
    wetlands: {
        pName: "Coastal Marshes",
        model: false,
        text: "More info about the importance of coastal marshes."
    }
})

onMounted(() => {
  if (activeLayerID.value != 'PEOPLE_SUMMARY'){
    loadDataByID('PEOPLE_SUMMARY', version)
  }
})
</script>
<style scoped>
.row-title{
    background-color: #cacaca;
}
</style>